import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Heart, Zap, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AboutPage() {
  return (
    <div>
      <section className="bg-[#F8D13F] py-16">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-[#1B2A4A]">Sobre BIGTIME</h1>
          <p className="mt-4 text-lg text-[#1B2A4A]/80">Todo en un solo lugar. Tu aliado favorito en Venezuela.</p>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <h2 className="text-3xl font-extrabold text-[#1B2A4A]">Nuestra misión</h2>
          <p className="mt-4 text-slate-600 leading-relaxed">En BIGTIME facilitamos productos de calidad a precios justos para que los negocios y familias venezolanas puedan crecer y ahorrar. Priorizamos un trato cercano, precios transparentes y entrega rápida.</p>
          <div className="mt-6 space-y-3">
            {[
              'Productos de calidad garantizada',
              'Atención personalizada por WhatsApp',
              'Envíos a todo el país',
              'Precios competitivos al mayor y detal',
            ].map((t) => (
              <div key={t} className="flex items-center gap-2 text-slate-700">
                <CheckCircle2 size={18} className="text-yellow-500" /> {t}
              </div>
            ))}
          </div>
          <Link to="/catalogo" className="inline-block mt-8">
            <Button className="bg-[#1B2A4A] hover:bg-[#141f38] text-yellow-300 rounded-full h-12 px-6 font-bold">Ver catálogo</Button>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[
            { icon: Heart, title: 'Compromiso', text: 'Cada cliente es prioridad' },
            { icon: Zap, title: 'Rapidez', text: 'Entregas eficientes' },
            { icon: Users, title: 'Comunidad', text: 'Apoyo al comerciante local' },
            { icon: CheckCircle2, title: 'Calidad', text: 'Productos seleccionados' },
          ].map((v, i) => (
            <div key={i} className="bg-white border-2 border-[#1B2A4A]/10 rounded-2xl p-5 hover:border-yellow-400 transition">
              <div className="w-11 h-11 rounded-full bg-[#F8D13F] text-[#1B2A4A] flex items-center justify-center mb-3">
                <v.icon size={22} />
              </div>
              <div className="font-bold text-[#1B2A4A]">{v.title}</div>
              <div className="text-sm text-slate-500 mt-1">{v.text}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
